import React, { useEffect, useState, useRef } from 'react';
import Post from '../components/Post';
import NewPostForm from '../components/NewPostForm';
import EchoUsername from "../components/EchoUsername";
import {Link, useNavigate} from "react-router-dom";
import AdBanner from '../components/AdBanner';
import Reels from '../components/Reels';
import echologo from '../utils/echo.png';
import { motion, AnimatePresence } from "framer-motion";
import { Button } from 'react-bootstrap';

const Home = () => {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const loader = useRef(null);
    const userDataJ = localStorage.getItem('echo_user_data');
    const userData = JSON.parse(userDataJ)
    const [ads, setAds] = useState([]);
    const [following, setFollowing] = useState([]);
    const [showPanel, setShowPanel] = useState(false);
    const [touchStartX, setTouchStartX] = useState(null);
    const panelRef = useRef();
    const [search, setSearch] = useState("");
    const [allUsers, setAllUsers] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [dndStatus, setdndStatus] = useState(false);

    const handleSearch = (e) => {
        if (e.key === 'Enter' && search.trim() !== '') {
            navigate(`/search?q=${encodeURIComponent(search.trim())}`);
        }
    };

    const dnd = () => {
        try {
            const res = fetch(`https://api.fantasyworldtrpg.cz/echo/dnd.php?dnd=${(dndStatus ? 0 : 1)}&u=${localStorage.getItem('echo_user')}`, {
                method: "GET",
                headers: { 'Content-Type': 'application/json' }
            });
            if (dndStatus) {
                setdndStatus(false);
            }
            else {
                setdndStatus(true);
            }
        }
        catch (err) {
            console.error("Chyba při načítání všech uživatelů:", err);
        }
    }

    useEffect(() => {
        const fetchAllUsers = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/search_all_users.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' }
                });
                const dndres = await fetch(`https://api.fantasyworldtrpg.cz/echo/getdnd.php?u=${localStorage.getItem('echo_user')}`, {
                    method: "GET",
                    headers: { 'Content-Type': 'application/json' }
                });
                const data = await res.json();
                const dataDND = await dndres.json();
                if (dataDND) {
                    const newStatus = (dataDND == 1 ? true : false);
                    setdndStatus(newStatus);
                }
                if (data.status === "success") {
                    setAllUsers(data.users);
                }
            } catch (err) {
                console.error("Chyba při načítání všech uživatelů:", err);
            }
        };

        fetchAllUsers();
    }, []);

    useEffect(() => {
        const q = search.trim().toLowerCase();
        if (!q) {
            setSearchResults([]);
            return;
        }

        const filtered = allUsers.filter(user =>
            user.name.toLowerCase().includes(q) ||
            (user.echo_nickname && user.echo_nickname.toLowerCase().includes(q))
        );

        setSearchResults(filtered.slice(0, 10));
    }, [search, allUsers]);


    useEffect(() => {
        const handleTouchStart = (e) => {
            const touchX = e.changedTouches[0].clientX;
            const screenWidth = window.innerWidth;

            // Pouze pokud se dotek začal v posledních 20 % obrazovky
            if (touchX > screenWidth * 0.8) {
                setTouchStartX(touchX);
            } else {
                setTouchStartX(null);
            }
        };

        const handleTouchEnd = (e) => {
            if (touchStartX === null) return;

            const deltaX = touchStartX - e.changedTouches[0].clientX;
            if (deltaX > 100) setShowPanel(true);
            if (deltaX < -100) setShowPanel(false);
        };

        const handleClickOutside = (e) => {
            if (panelRef.current && !panelRef.current.contains(e.target)) {
                setShowPanel(false);
            }
        };

        window.addEventListener('touchstart', handleTouchStart);
        window.addEventListener('touchend', handleTouchEnd);
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            window.removeEventListener('touchstart', handleTouchStart);
            window.removeEventListener('touchend', handleTouchEnd);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [touchStartX]);


    useEffect(() => {
        if (!userData?.id) return;

        const fetchFollowing = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/get_following.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user: userData.id })
                });
                const data = await res.json();
                if (data.status === 'success') {
                    setFollowing(data.following);
                }
            } catch (err) {
                console.error("Chyba při načítání sledovaných:", err);
            }
        };

        fetchFollowing();
        const interval = setInterval(fetchFollowing, 20000);

        return () => clearInterval(interval);
    }, [userData?.id]);



    const handleNewPost = () => {
        setPage(1);
        setHasMore(true);
        setPosts([]);
        fetchPosts(1);
    };

    const RotatingImage = ({ src }) => {
        return (
            <motion.img
                src={src}
                alt="Rotující obrázek"
                style={{ width: 150, height: 150, borderRadius: "50%" }}
                animate={{ rotate: 360 }}
                transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
            />
        );
    };

    const fetchAds = async () => {
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/echo_ads.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            const data = await res.json();
            if (data.status === 'success') {
                setAds(data.ads || []);
            }
        } catch (err) {
            console.error('Chyba při načítání reklam:', err);
        }
    };

    useEffect(() => {
        fetchAds();
    }, []);


    const [topUsers, setTopUsers] = useState([{avatar: echologo, id: 1}]);
    const [topPosts, setTopPosts] = useState([{name: "Načítání..."}]);
    const fullUrl = (path) => {
        if (!path) return null;
        return path.startsWith('http') ? path : `https://fantasyworldtrpg.cz${path}`;
    };
    const homeLoad = async () => {
        try {
            const top = await fetch('https://api.fantasyworldtrpg.cz/echo/home.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            const topPost = await fetch('https://api.fantasyworldtrpg.cz/echo/topposts.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            const data = await top.json();
            if (data.status == "success") {
                setTopUsers(data.top)
            }
            else {
                setTopUsers(null)
            }

            const dataTP = await topPost.json();
            if (dataTP.status == "success") {
                setTopPosts(dataTP.posts);
            }
            else {
                setTopPosts(null)
            }
        }
        catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        const uid = localStorage.getItem("echo_user");
        if (!uid) return;

        const ping = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/online.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ uid })
                });

                const data = await res.json();
                if (data.success && Array.isArray(data.onlineUsers)) {
                    setOnlineUsers(data.onlineUsers);
                }
            } catch (err) {
                console.error("Chyba při pingnutí online:", err);
            }
        };

        ping();

        const interval = setInterval(ping, 20000);

        return () => clearInterval(interval);
    }, []);


    const fetchPosts = async (pageNum) => {
        if (loading || !hasMore) return;
        setLoading(true);
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/posts.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    echo_user: localStorage.getItem('echo_user'),
                    page: pageNum
                })
            });

            const data = await res.json();
            if (data.status === 'success' && Array.isArray(data.posts)) {
                if (data.posts.length === 0) {
                    setHasMore(false);
                } else {
                    setPosts((prev) => [...prev, ...data.posts]);
                    setPage(prev => prev + 1); // posun na další stránku
                }
            }
        } catch (err) {
            console.error('Chyba při načítání postů:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts(1);
    }, []);

    useEffect(() => {
        homeLoad()
    }, [])

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !loading && hasMore) {
                    fetchPosts(page);
                }
            },
            { threshold: 1 }
        );

        if (loader.current) observer.observe(loader.current);

        return () => {
            if (loader.current) observer.unobserve(loader.current);
        };
    }, [loading, hasMore, page]);
    return (
        <div className="container-fluid py-5 my-5">
            <div className="row">
                {/* Levý sloupec */}
                <div className="col-12 col-md-3 mb-3">
                    <div className="mb-4">
                        <div className="position-relative d-flex">
                            <i className="bi bi-search position-absolute"
                               style={{left: 10, top: '50%', transform: 'translateY(-50%)', color: '#aaa'}}></i>
                            <input
                                type="search"
                                className="form-control ps-5"
                                placeholder="Hledat"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={handleSearch}
                            />
                            <button
                                className="btn btn-danger ms-2"
                                onClick={() => {
                                    if (search.trim()) navigate(`/search?q=${encodeURIComponent(search.trim())}`);
                                }}
                            >
                                Hledat
                            </button>
                        </div>
                        {searchResults.length > 0 && (
                            <div
                                className="border rounded bg-white shadow-sm mt-2 p-2"
                                style={{
                                    zIndex: 999,
                                    position: 'absolute',
                                    maxWidth: '300px',
                                    width: '100%'
                                }}
                            >
                                {searchResults.map(user => (
                                    <div
                                        key={user.id}
                                        className="d-flex align-items-center p-2 hover-bg"
                                        style={{cursor: "pointer"}}
                                        onClick={() => navigate(`/profile/${user.id}`)}
                                    >
                                        <img
                                            src={fullUrl(user.img || user.avatar)}
                                            alt={user.name || user.echo_nickname}
                                            className="rounded-circle me-2"
                                            style={{width: 35, height: 35, objectFit: "cover"}}
                                        />
                                        <div>
                                            <strong>{user.name || user.echo_nickname}</strong><br/>
                                            <small className="text-secondary">@{user.echo_nickname || user.name}</small>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>
                    <Reels user={userData} />
                    <div className="border rounded my-3 p-3 bg-light shadow-sm">
                        <img style={{cursor: "pointer"}} onClick={() => navigate(`/profile/${userData.id}`)}
                             className="rounded-circle avatar mx-2" width="40" height="40" src={fullUrl(userData.img)}/>
                        <EchoUsername userId={userData.id} name={userData.name}
                                      accountType={userData.account_type} onlineUsers={onlineUsers}></EchoUsername>
                        <div className="lead mt-4">Nejsledovanější uživatelé</div>
                        {Array.isArray(topUsers) && topUsers.map((user, index) => {
                            return (
                                <Link to={`/profile/${user.id}`} key={user.id}>
                                    <img style={{
                                        height: "50px",
                                        width: "50px",
                                        borderRadius: "50%",
                                        margin: "5px",
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    }} src={fullUrl(user.avatar)}/>
                                </Link>
                            )
                        })}
                    </div>
                    <div className="border rounded d-none d-md-block my-3 p-3 bg-light shadow-sm">
                        <div className="lead mt-4">Top příspěvky</div>
                        {
                            Array.isArray(topPosts) && topPosts.map((p, index) => {
                                return (
                                    <Link to={`/post/${p.id}`} key={p.id}>
                                        <div className="my-3">
                                            <div style={{
                                                fontWeight: "bold",
                                                textDecoration: "none"
                                            }}>@{p.name}</div>
                                            <img style={{
                                                objectFit: "cover",
                                                objectPosition: "center",
                                                width: "100%"
                                            }} className="img-fluid" src={p.image}/>
                                        </div>
                                    </Link>
                                )
                            })
                        }
                    </div>
                </div>

                {/* Prostřední sloupec */}
                <div className="col-12 col-md-6 mb-3">
                    <NewPostForm avatar={userData} onNewPost={handleNewPost}/>
                    {posts.map((post, index) => (
                        <React.Fragment key={post.id}>
                            <Post post={post} onlineUsers={onlineUsers}/>
                            {(index + 1) % 10 === 0 && ads.length > 0 && (
                                <AdBanner ad={ads[(index / 10) % ads.length | 0]}/>
                            )}
                        </React.Fragment>
                    ))}
                    {hasMore && (
                        <div ref={loader} className="text-center text-secondary py-3">
                            ⏳ Načítám příspěvky...
                            <br/>
                            <RotatingImage className="mt-3" style={{maxHeight: "200px"}} src={echologo}/>
                        </div>
                    )}
                    {!hasMore && (
                        <div className="text-center text-secondary py-3">
                            ✅ Všechno načteno. Už není co dalšího ti ukázat. Jdi ven.
                        </div>
                    )}
                </div>

                {/* PC PANEL*/}
                <div className="col-12 col-md-3 mb-3 d-none d-md-block">
                    <div className="border rounded p-3 bg-light shadow-sm mb-3">
                        <h5 className="mb-3">Sleduji</h5>
                        <div className="my-3">
                            <span onClick={() => dnd()} style={{cursor: "pointer"}}>
                                {(!dndStatus ? (<><i className="bi bi-toggle2-on text-success"></i> Online</>) : (
                                    <><i className="bi bi-toggle2-off text-danger"></i> Nerušit</>))}
                            </span>
                        </div>
                        {following.length === 0 && <p className="text-secondary">Nikoho nesleduješ.</p>}
                        {following.map((user) => (
                            <div key={user.id} className="d-flex align-items-center mb-2">
                                <img
                                    src={fullUrl(user.avatar)}
                                    alt={user.display_name}
                                    className="rounded-circle me-2"
                                    style={{width: 35, height: 35, objectFit: 'cover', cursor: 'pointer'}}
                                    onClick={() => navigate(`/profile/${user.id}`)}
                                />
                                <div>
                                    <Link to={`/profile/${user.id}`} className="text-decoration-none">
                                        <strong>{user.display_name}</strong>
                                    </Link>
                                    <span title="Poslat zprávu" style={{cursor: "pointer"}} onClick={() => navigate(`/chat/${user.id}`)} className="ms-2"><i className="bi bi-send-fill main-text"></i></span>
                                    <br/>
                                    <small
                                        className={
                                            onlineUsers.includes(user.id)
                                                ? user.echo_dnd === "1"
                                                    ? 'text-danger'
                                                    : 'text-success'
                                                : 'text-secondary'
                                        }
                                    >
                                        <i className="bi bi-circle-fill"></i>{' '}
                                        {onlineUsers.includes(user.id)
                                            ? user.echo_dnd === "1"
                                                ? 'Nerušit'
                                                : 'Online'
                                            : 'Offline'}
                                    </small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* MOBILNÍ PANEL */}
                <AnimatePresence>
                    {showPanel && (
                        <motion.div
                            className="d-md-none position-fixed top-0 end-0 h-100 bg-light shadow-lg"
                            initial={{x: '100%'}}
                            animate={{x: 0}}
                            exit={{x: '100%'}}
                            transition={{duration: 0.3}}
                            style={{width: '80vw', zIndex: 9999}}
                        >
                            <div ref={panelRef} className="p-3 h-100 overflow-auto">
                                <button className="btn btn-danger btn-sm mb-3"
                                        onClick={() => setShowPanel(false)}>Zavřít
                                </button>
                                <h5 className="mb-3">Sleduji</h5>
                                <div className="my-3">
                                    <span onClick={() => dnd()} style={{cursor: "pointer"}}>
                                        {(!dndStatus ? (<><i className="bi bi-toggle2-on text-success"></i> Online</>) : (
                                            <><i className="bi bi-toggle2-off text-danger"></i> Nerušit</>))}
                                    </span>
                                </div>
                                {following.length === 0 && <p className="text-secondary">Nikoho nesleduješ.</p>}
                                {following.map((user) => (
                                    <div key={user.id} className="d-flex align-items-center mb-2">
                                        <img
                                            src={fullUrl(user.avatar)}
                                            alt={user.display_name}
                                            className="rounded-circle me-2"
                                            style={{width: 35, height: 35, objectFit: 'cover', cursor: 'pointer'}}
                                            onClick={() => {
                                                setShowPanel(false);
                                                navigate(`/profile/${user.id}`);
                                            }}
                                        />
                                        <div>
                                            <Link to={`/profile/${user.id}`} className="text-decoration-none">
                                                <strong>{user.display_name}</strong>
                                            </Link>
                                            <span style={{cursor: "pointer"}}
                                                  onClick={() => navigate(`/chat/${user.id}`)} className="ms-2"><i
                                                className="bi bi-send-fill main-text"></i></span>
                                            <br/>
                                            <small
                                                className={
                                                    onlineUsers.includes(user.id)
                                                        ? user.echo_dnd === "1"
                                                            ? 'text-danger'
                                                            : 'text-success'
                                                        : 'text-secondary'
                                                }
                                            >
                                                <i className="bi bi-circle-fill"></i>{' '}
                                                {onlineUsers.includes(user.id)
                                                    ? user.echo_dnd === "1"
                                                        ? 'Nerušit'
                                                        : 'Online'
                                                    : 'Offline'}
                                            </small>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
};

export default Home;
